/**
 * Teto de emissão por falha recorrente, com contador de repetição.
 *
 * O estado vive no módulo, e não em instância de componente, para que uma remontagem
 * da árvore React não zere o teto da sessão — é justamente o erro em loop de render
 * que remonta a árvore e que o teto existe para conter.
 */

export const MAX_EMISSIONS_PER_FINGERPRINT = 5;

export interface OccurrenceResult {
  /** Total de observações do fingerprint na sessão, incluindo as suprimidas. */
  readonly occurrences: number;
  readonly shouldEmit: boolean;
}

const occurrencesByFingerprint = new Map<string, number>();

/**
 * Registra uma observação do fingerprint e informa se ela deve ser emitida.
 *
 * O contador incrementa sempre, inclusive depois do teto: o número real de repetições
 * continua conhecido no runtime mesmo quando não chega mais ao painel.
 */
export function registerOccurrence(fingerprint: string): OccurrenceResult {
  const occurrences = (occurrencesByFingerprint.get(fingerprint) ?? 0) + 1;
  occurrencesByFingerprint.set(fingerprint, occurrences);

  return {
    occurrences,
    shouldEmit: occurrences <= MAX_EMISSIONS_PER_FINGERPRINT,
  };
}

/** Descarta o estado de módulo entre testes. Não usar em código de produção. */
export function resetDedupeForTests(): void {
  occurrencesByFingerprint.clear();
}
